import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import { useHistory } from "react-router-dom";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BusinessImage from "./BusinessImage";
import { GetPhotoProfile } from "../User/Infrastructure/User.presenter";

const businessImageStyles = {
  width: 101,
  height: 101,
  borderRadius: "5px"
}

const scheduleContainer = {
  width: "360px",
  height: "auto",
  background: "#F2F2F2",
  borderRadius: "10px",
  padding: "15px 30px"
}

const headerInfo = {
  display: "flex",
  justifyContent:"flex-start",
  alignItems: "center",
  gap: "12px"
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "15px 20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
    border: "1px solid #E5E5E5",
    borderRadius: "10px",
    maxWidth: 450,
    minHeight: 126,
    height: "auto",
    width: "100%",
    "&:hover":{
      cursor: "pointer",
      background: "#E0E0E0"
    },
    margin: "10px auto"
    /* [theme.breakpoints.down("lg")]:{
      margin: "30px auto"
    } */
  },
  infoContainer:{
    width: "100%",
    textAlign: "left"
  },
  businessName:{ // Roboto
    fontSize: "1.5rem",
    fontWeight: 500,
    marginBottom: 10,
  },
  businessDescription:{
    fontSize: "1.125rem",
    color: "#828282",
    fontWeight: 400,
    height: 43,
    width: 197,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  hours:{
    fontSize: "1.125rem",
    color: "#828282",
    fontWeight: 400,
    display: "flex",
    alignItems: "flex-end",
    marginTop: 10,
  }
}));

export default function BusinessCard({id, name, image, schedule, description}){
  const classes = useStyles();
  const history = useHistory();
  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(true);
  const [breakpoint, setBreakpoint] = useState(window.innerWidth <= 768 ? true : false);

  const handleResizeTitle = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      setBreakpoint(true);
    } else if (screenWidth >= 769) {
      setBreakpoint(false);
    }
  };

  const getUrlPhoto = async (urlPhoto) =>{
    const res = await GetPhotoProfile(urlPhoto);
    setPhoto(res);
  }

  useEffect(() => {
    if (image) {
      getUrlPhoto(image)
    }
    setLoading(false);
  }, [image]);

  useEffect(() => {
    window.addEventListener("resize", handleResizeTitle);
    window.addEventListener("load", handleResizeTitle);
    return () => {
      window.removeEventListener("resize", handleResizeTitle);
      window.addEventListener("load", handleResizeTitle);
    };
  }, []);

  return !loading && (
    <Card className={classes.root} sx={{boxShadow: "none"}} onClick={() => history.push(`/negocio/${id}`)} >
    <BusinessImage businessImage={photo} customStyles={businessImageStyles}/>
    <div className={classes.infoContainer}>
      <h3 className={classes.businessName}>{name}</h3>
      <p className={classes.businessDescription}>
        {description === null ? "Sin descripción" : description}
      </p>
      {breakpoint ? (
        (typeof(schedule) !== "string" && schedule.length !== 0) &&  
        <Box sx={scheduleContainer}>
        <Box sx={headerInfo}>
            <AccessTimeIcon sx={{color: "#EA5B13", width: "24px", height: "24px"}}/>
            {/* <h4 className={classes.titleInfo}>Horario</h4> */}
            </Box>
            {schedule.map( (day, index) => <p key={index} style={{marginTop: "7px", marginBottom: "7px"}}>{day}</p> )}
          </Box>

      /* (
        <p className={classes.hours} >
          {schedule === null ? "" : <AccessTimeIcon/>} {schedule === null ? "" : schedule}
        </p>
       */) : (<></>)}
    </div>
  </Card>
  );
}

BusinessCard.defaultProps = {
  image: "",
  schedule: "",
  description: "",
};

BusinessCard.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
  schedule: PropTypes.string,
  description: PropTypes.string,
};